<template lang="pug">
  .b2b-table-ocr-documents
    //- Filtro Tabla OCR Documents
    b2b-filters-ocr-documents(
      :filter-options='options')

    //- Tabla de OCR Documents
    ods-table(
      :data='ocrDocuments ? ocrDocuments.tableData : []',
      :start-sort='{ prop: "creationDateTime", order: "descending"}',
      style='width: 100%',
      @sort-change="orderOnServer",
      @cell-mouse-enter='handleCellMouseEnter',
      @selection-change='handleSelectionChange',
      highlight-current-row,
      size='small',
      fit)
      ods-table-column(
        type='selection',
        width='55')
      ods-table-column(
        prop='documentName',
        :label='$t("ocr.documents_entity_table.document_name")',
        :show-overflow-tooltip='true',
        v-if='isShowDocumentNameOcrDocuments',
        sortable='')
      ods-table-column(
        prop='emailFrom',
        :label='$t("ocr.documents_entity_table.email_from")',
        :show-overflow-tooltip='true',
        v-if='isShowEmailToOcrDocuments',
        sortable='')
      ods-table-column(
        prop='mailServer',
        :label='$t("ocr.documents_entity_table.mail_server")',
        :show-overflow-tooltip='true',
        v-if='isShowMailServerOcrDocuments',
        sortable='')
      ods-table-column(
        prop='statusDocument',
        :label='$t("ocr.documents_entity_table.status_document")',
        v-if='isShowStatusDocumentOcrDocuments',
        sortable='')
        template(slot-scope='scope')
          ods-tooltip(placement='top')
            template(slot='content')
              | {{ formatterTooltipStatusDocument(scope.row, scope.column) }}
            div.text-overflow-tooltip
              | {{ formatterStatusDocument(scope.row, scope.column) }}
      ods-table-column(
        prop='projectName',
        :label='$t("ocr.documents_entity_table.project")',
        :show-overflow-tooltip='true',
        v-if='isShowProjectOcrDocuments',
        sortable='')
      ods-table-column(
        prop='documentType',
        :label='$t("ocr.documents_entity_table.document_type")',
        :show-overflow-tooltip='true',
        v-if='isShowDocumentTypeOcrDocuments',
        sortable='')
        template(slot-scope='scope')
          ods-tooltip(placement='top')
            template(slot='content')
              | {{ formatterDocumentType(scope.row, scope.column) }}
            div.text-overflow-tooltip
              | {{ formatterDocumentType(scope.row, scope.column) }}
      ods-table-column(
        prop='creationDateTime',
        :label='$t("ocr.documents_entity_table.creation_date")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowCreationDateTimeOcrDocuments',
        :formatter='formatterDateTime',
        sortable='')
      ods-table-column(
        prop='ocrProcessDate',
        :label='$t("ocr.documents_entity_table.ocr_process_date")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowOcrProcessDateOcrDocuments',
        :formatter='formatterDateTime',
        sortable='')
      ods-table-column(
        width='50')
        template(slot-scope='scope')
          //- Adjuntos
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('ocr.documents_entity_table.attachments') }}
            ods-icon(
              v-if='scope.row.withAttachment!==null && scope.row.withAttachment',
              name='clip',
              size='16')
      ods-table-column(
        label,
        :render-header='renderHeaderActions',
        width='80')
        template(slot-scope='scope')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.detail') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral',
              @click='handleGoValidationPage(scope.row)')
              ods-icon(name='search', size='16')

    //- Paginación Tabla
    ods-row.b2b-table-ocr-documents__pagination(v-if='ocrDocuments.totalOcrDocuments > 0')
      ods-col.b2b-table-usuarios__pagination--right(:span='4')
        ods-tooltip(:content='$t("invoices.buttons.download_csv_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            size='mini',
            round='',
            icon='ods-icon-download'
            style='display:inline;'
            @click='handleDownloadOcrCsv')
            | CSV
      //- Paginación
      ods-col.b2b-table-ocr-documents__pagination--right(:span='24')
        div.block(style='margin-bottom: 50px;')
          ods-pagination(
            ref='pagination',
            popper-class='b2b-pagination__dropdown',
            @size-change='handleSizeChange',
            @current-change='handleCurrentChangePagination',
            :current-page.sync='currentPage',
            :page-sizes='[20, 50, 100]',
            :page-size='20',
            layout='total, sizes, prev, pager, next, slot',
            :total='ocrDocuments.totalOcrDocuments')

      //- OCR Documents Seleccionados
      transition(
        name='slide',
        mode='out-in')
        b2b-table-select-rows(
          v-if='multipleSelection.length',
          :total-select='multipleSelection.length')
          div(slot='actions')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bFiltersOcrDocuments from '@/views/facturas/ocrDocument/B2bFiltersOcrDocuments'
import B2bTableMenuOcrDocuments from './B2bTableMenuOcrDocuments'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import filters from './filtros-ocr-documents'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-table-ocr-documents',
  mixins: [Utils],
  data () {
    return {
      // Tabla
      currentRow: {},
      multipleSelection: [],
      multipleSelectionIds: [],
      // Paginación
      totalResults: 0,
      currentPage: 0
    }
  },
  computed: {
    ...mapGetters([
      'ocrDocuments',
      'queryOcrDocuments',
      'totalOcrDocuments',
      'optionsFilterCurrency',
      'getActiveLang',
      'isShowDocumentNameOcrDocuments',
      'isShowEmailToOcrDocuments',
      'isShowStatusDocumentOcrDocuments',
      'isShowProjectOcrDocuments',
      'isShowMailServerOcrDocuments',
      'isShowDocumentTypeOcrDocuments',
      'isShowCreationDateTimeOcrDocuments',
      'isShowOcrProcessDateOcrDocuments'
    ])
  },
  components: {
    B2bFiltersOcrDocuments,
    B2bTableMenuOcrDocuments,
    B2bTableSelectRows
  },
  watch: {
    '$route' (to) {
      this.ocrDocuments = this.ocrDocuments // eslint-disable-line
    }
  },
  methods: {
    ...mapActions([
      'getOptionsService',
      'getOcrDocuments',
      'queryOcrDocumentsState',
      'loadFilterOcrDocumentType',
      'loadFilterOcrDocumentMailServer',
      'loadFilterStatusDocumentByType',
      'handleDownloadAllCsvOcrDocuments',
      'deleteOcrDocument',
      'optionsServicesEnabledState'
    ]),

    async orderOnServer ({ column, order, prop }) {
      let stringSort = ''
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.order_table')
      })

      if (order === 'descending') {
        order = 'DESC'
      } else if (order === 'ascending') {
        order = 'ASC'
      } else {
        order = 'ASC'
      }

      if (prop === 'ocrProcessDate') {
        prop = 'ocrProcessDateTime'
      } else if (!prop) {
        prop = 'creationDateTime'
      }

      stringSort = prop + ',' + order
      this.queryOcrDocuments.sort = stringSort

      try {
        await this.queryOcrDocumentsState(this.queryOcrDocuments)
        dataQuery.query = this.queryOcrDocuments
        const ocrDocuments = await this.getOcrDocuments(dataQuery)

        this.totalResults = ocrDocuments.data.totalElements
      } catch (error) {
        console.log('orderOnServer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },

    handleSelectionChange (val) {
      this.multipleSelection = val

      if (val.length === 0) {
        this.multipleSelection = []
      }

      this.multipleSelection = this.multipleSelection.filter(item => {
        const param = item.id
        this.multipleSelectionIds.push(param)
        return item
      })
    },

    // Redirigir a la página de validación de documentos OCR
    handleGoValidationPage () {
      console.log('documentName ' + this.currentRow.documentName)
      console.log('documentId ' + this.currentRow.id)
      sessionStorage.setItem('documentName', this.currentRow.documentName)
      router.push({
        name: 'page-ocr-document',
        params: {
          documentId: this.currentRow.id,
          documentName: this.currentRow.documentName,
          projectName: this.currentRow.projectName
        }
      })
    },

    formatterTooltipStatusDocument (row, column) {
      if (row.messageStatus && row.messageStatus !== '') return this.formatterStatusDocument(row, column) + ' - ' + row.messageStatus
      else return this.formatterStatusDocument(row, column)
    },

    // Formatear estado del documento
    formatterStatusDocument (row, column) {
      if (!row[column.property]) {
        return ''
      }
      return this.$t('invoice_status.' + row[column.property])
    },

    // Formatear tipo documento
    formatterDocumentType (row, column) {
      return this.$t('auditory_doc_type.' + row[column.property])
    },

    // Formatear divisa
    formatterCurrency (row, column) {
      if (row[column.property]) {
        return this.$t('currency.' + row[column.property])
      } else {
        return ''
      }
    },

    // Formatear dinero Tabla
    formatterMoney (row, column) {
      const currency = this.optionsFilterCurrency.find(e => e.code === row.currencyCode)
      let negative = false
      let money = this.$n(row[column.property], 'table')
      // le quitamos la parte negativa
      if (money.startsWith('-')) {
        negative = true
        money = money.substring(1)
      }
      // para la longitud de 7 (nnnn,nn)la función $n no le pone el separador de miles
      // lo hacemos manualmente
      if (money.toString().length === 7) {
        const part1 = money.substring(0, 1)
        const part2 = money.substring(1, 7)
        money = part1 + '.' + part2
      }
      // Añadimos la divisa si la tiene
      if (currency && currency.symbol) {
        money += ' ' + currency.symbol
      }
      // si la cantidad era negativa se le pone el menos
      if (negative) {
        money = '-' + money
      }
      return money
    },

    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format'))
      }
      return this.$t('msg_generics.no_date')
    },

    /* Formatear columna: Fecha */
    formatterDateTime (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },

    renderHeaderActions: h => {
      return <B2bTableMenuOcrDocuments />
    },

    // Tamaño Tabla (20,50,100)
    async handleSizeChange (val) {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.size_table')
      })
      this.queryOcrDocuments.size = val

      try {
        await this.queryOcrDocumentsState(this.queryOcrDocuments)
        dataQuery.query = this.queryOcrDocuments

        const ocrDocuments = await this.getOcrDocuments(dataQuery)
        this.totalResults = ocrDocuments.data.totalElements
      } catch (error) {
        console.log('handleSizeChange CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Paginacion

    async handleDownloadOcrCsv () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_csv')
      })
      const params = this.queryOcrDocuments
      try {
        params.activeLang = this.getActiveLang
        const filename = await this.handleDownloadAllCsvOcrDocuments(params)
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadOcrCsv CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async handleCurrentChangePagination (val) {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.pagination_table')
      })
      this.queryOcrDocuments.page = val - 1

      try {
        await this.queryOcrDocumentsState(this.queryOcrDocuments)
        dataQuery.query = this.queryOcrDocuments

        const ocrDocuments = await this.getOcrDocuments(dataQuery)
        this.totalResults = ocrDocuments.data.totalElements
      } catch (error) {
        console.log('handleCurrentChangePagination CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getNotificationErrorMessage (error) {
      const statusCode = error.status
      let errorSms = ''
      switch (statusCode) {
        case 400:
          errorSms = this.$t('error.e400')
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 403:
          errorSms = this.$t('error.e403')
          break
        case 500:
          errorSms = this.$t('error.e500')
          break
        default:
          errorSms = this.$t('error.e500')
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }

  },
  async created () {
    const dataQuery = {
      query: {}
    }
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    this.options = filters.filters
    try {
      const dataQueryProj = { page: 0, size: 1000, sort: 'name,ASC' }
      const optionsFilterService = await this.getOptionsService(dataQueryProj)
      await this.optionsServicesEnabledState(optionsFilterService)

      if (optionsFilterService.length === 1) {
        this.queryOcrDocuments.projectId = optionsFilterService[0].id
      }

      // Cargamos los datos de los filtros
      this.loadFilterOcrDocumentType()
      this.loadFilterOcrDocumentMailServer({ query: { projectId: this.queryOcrDocuments.projectId } })
      this.loadFilterStatusDocumentByType({ type: 'INVOICE' })

      dataQuery.query = this.queryOcrDocuments
      const ocrDocuments = await this.getOcrDocuments(dataQuery)

      this.totalResults = ocrDocuments.data.totalElements
    } catch (error) {
      console.log('OCR Documents created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-table-ocr-documents {
  ::v-deep .ods-table {
    th {
      padding: rem(0);
      padding-top: rem(4);

      .cell {
        font-weight: 500;
      }

      &:last-child {
        padding-top: rem(0);
        .cell {
          .ods-dropdown {
            line-height: 32px;
          }
        }
      }
      .cell:last-child {
        .ods-dropdown {
          line-height: 32px;
        }
      }
    }
    &__row {
      .cell {
        .text-overflow-tooltip {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .ods-button {
        padding: rem(1) rem(15) rem(0) rem(15);
        margin-left: rem(0);
        margin-right: 0.2rem;
        i {
          margin-left: rem(0);
        }
      }
    }
  }

  ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .block {
        float: right;
      }
      .ods-pagination {
        padding-top: rem(0);
        float: right;
        &__label {
          padding-top: rem(0);
          float: right
        }
      }
    }
  }
}
</style>
